module.exports = __webpack_public_path__ + "assets/img/free_20.01b34262.png";